const EarningCertificateService = class EarningCertificateService {
  constructor ($http, Configuration) {
    'ngInject'
    this.$http = $http
    this.Configuration = Configuration
  }

  generateEarningCertificate (payload) {
    return this.$http
      .post(`${this.Configuration.apiUrl}/experts/earnings_certificates`, payload)
      .then(response => {
        return response.data
      })
  }

  getEarningCertificates () {
    return this.$http
      .get(`${this.Configuration.apiUrl}/experts/earnings_certificates`)
      .then(response => {
        return response.data
      })
  }

  getEarningCertificateById (id) {
    return this.$http
      .get(`${this.Configuration.apiUrl}/experts/earnings_certificates/${id}`)
      .then(response => {
        return response.data
      })
  }
}
export default EarningCertificateService
